import React, { Component } from "react";
import styled from "styled-components";

// Utility function for formatting info
const FuctionSection = styled.div`
  border: 1.5px solid #e6eaef;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;

  .details-row {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .detail-item {
    // width: 50%; /* Adjust this for layout */
    // margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .detail-key {
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.03em;
    color: #858585;
  }

  .detail-value {
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.03em;
    text-align: left;

    color: #000000;
  }
`;

const SummarySection = styled.div`
  border: 1.5px solid #e6eaef;
  border-radius: 8px;
  padding: 15px;
  background: #f4f8ff;

  .header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  .text {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.03em;
    text-align: left;
    color: #0566ff;
    margin: 0px 10px;
  }

  .sentiment {
    margin-left: auto;
  }

  .sentiment span {
    border-radius: 8px;
    border: 1.5px solid #e6eaef;
    padding: 6px;
    margin: -23px;
    background: #fff;
  }
  .topic {
    display: flex;
    align-items: start;
    background: #ffffff;
    padding: 10px;
    margin-bottom: 15px;
  }

  .topic-text {
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.03em;
    color: #000000;
    margin-right: 16px;
  }

  .topic-content {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    letter-spacing: 0.03em;
    color: #647491;
  }

  .summary-content p {
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.03em;
    color: #000000;
    line-height: 20px;
    margin: 0px;
  }
`;

const TagsSection = styled.div`
  border: 1.5px solid #e6eaef;
  border-radius: 8px;
  padding: 15px;
  margin: 20px 0px;

  .tag {
    display: inline-flex;
    align-items: center;
    background-color: #dfd8fd;
    border-radius: 20px;
    padding: 5px 14px;
    font-size: 14px;
    color: #5e4db2;
    font-weight: 700;
  }

  .delete-btn {
    margin-left: 8px;
    color: #889198;
    cursor: pointer;
    font-size: 18px;
  }

  .tag-list {
    display: flex;
    gap: 10px;
  }

  .tag:hover {
    opacity: 0.85;
  }
`;

const DetailSection = styled.div`
  border: 1.5px solid #e6eaef;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;

  .details-row {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .detail-item {
    width: 50%; /* Adjust this for layout */
    margin-bottom: 10px;
  }

  .detail-key {
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.03em;
    color: #858585;
  }

  .detail-value {
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.03em;
    text-align: left;

    color: #000000;
  }

  .details-table,
  .long-value-table {
    width: 100%;
    border-collapse: collapse;
    // margin-bottom: 20px; /* Spacing between tables */
  }

  .details-table td,
  .long-value-table td {
    padding: 5px 10px;
    border: none;
  }

  .details-table .detail-key {
    font-weight: 500;
    // width: 50%;
  }

  .details-table .detail-value {
    // width: 50%;
  }

  .long-value-table .long-value-row {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 31%;
    font-weight: 500;
  }
`;

const ChecklistSection = styled.div`
  border: 1.5px solid #e6eaef;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;

  .checklist {
    display: flex;
    align-items: center;
    gap: 45px;
  }

  .checklist-label {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
  }

  .checklist-label span {
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.03em;
  }

  // .checklist-label {
  //   position: relative;
  //   display: inline-block;
  // }

  .tooltip {
    opacity: 1 !important;
  }

  .tooltip-text {
    visibility: hidden;
    background-color: black;
    color: #fff;
    text-align: left;
    border-radius: 5px;
    padding: 10px;
    position: absolute;
    z-index: 1;
    // top: -40px; /* Adjust this to position tooltip */
    // left: 105%; /* Adjust for positioning next to the element */
    width: max-content; /* Adjust width as per content */
    // max-width: 200px;
    white-space: nowrap;
    opacity: 1;
    bottom: 38px;
  }

  .tooltip:hover .tooltip-text {
    visibility: visible;
  }

  .formate-info {
    color: #b4b4b4;
    font-size: 12px;
    font-weight: 600;
    text-align: left;
  }

  .formate-value {
    color: #fbfbfb;
    font-size: 12px;
    font-weight: 600;
    text-align: left;
  }
`;

const HeadingStyle = styled.div`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.03em;
  text-align: left;
  color: #000000;
  margin-bottom: 16px;
`;

const AccordionSection = styled.div`
  .accordion {
    border: 1.5px solid #e6eaef;
    border-radius: 8px;
  }
  .accordionContainer {
    border-bottom: 1.5px solid #e6eaef;
    background: #f4f8ff;
    border-radius: 8px;
    padding: 4px 15px;
  }
  .header {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .title {
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.03em;
    color: #000000;
    margin-right: 25px;
  }
  .score {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.03em;
    color: #000000;
    margin-left: auto;
  }
  .arrow {
    font-size: 22px;
    margin-left: 30px;
    color: #1c1b1f;
  }
  .content {
    padding: 10px 15px;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.03em;
    color: #000;
    margin: 0;
  }
`;
const formatInfo = (info) => {
  // Check if info is valid and not "None"
  if (!info || info === "None") return [];

  // Ensure info is a string
  const infoString = typeof info === "string" ? info : JSON.stringify(info);

  // Use match to find pairs in the infoString
  const matches = infoString.match(/(\w+):([^,]+)(?=,|$)/g);

  // If no matches found, return an empty array
  if (!matches) return [];

  // Map over matches to create key-value pairs
  const infoPairs = matches.map((item) => {
    const [key, value] = item.split(":");
    const values = value.split(",").map((val) => val.trim());
    return { key: key.trim(), values }; // Return as an object
  });

  return infoPairs; // Return an array of objects
};

// Utility function to render sentiment icon
const getSentimentIcon = (sentiment) => {
  switch (sentiment) {
    case "Neutral":
      return (
        <span className="material-symbols-outlined" style={{ color: "black" }}>
          sentiment_neutral
        </span>
      );
    case "Positive":
      return (
        <span className="material-symbols-outlined" style={{ color: "green" }}>
          sentiment_satisfied
        </span>
      );
    case "Negative":
      return (
        <span className="material-symbols-outlined" style={{ color: "red" }}>
          sentiment_dissatisfied
        </span>
      );
    default:
      return null;
  }
};

// Utility to render rows for details
const createRows = (details) => {
  const rows = [];
  let tempRow = [];
  Object.keys(details).forEach((key, index) => {
    tempRow.push(
      <React.Fragment key={index}>
        <td className="detail-key">{key}:</td>
        <td className="detail-value">{details[key]}</td>
      </React.Fragment>
    );
    if ((index + 1) % 2 === 0 || index === Object.keys(details).length - 1) {
      if (index + 1 === Object.keys(details).length && tempRow.length < 2) {
        tempRow.push(
          <td key={`empty-key-${index}`} style={{ width: "30%" }} />
        );
        tempRow.push(
          <td key={`empty-value-${index}`} style={{ width: "30%" }} />
        );
      }
      rows.push(<tr key={index}>{tempRow}</tr>);
      tempRow = [];
    }
  });
  return rows;
};

class SummarySectionComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: [], // Manage accordion state
    };
  }

  toggleAccordion = (index) => {
    this.setState((prevState) => {
      const isOpen = prevState.isOpen.includes(index);
      const updatedIsOpen = isOpen
        ? prevState.isOpen.filter((i) => i !== index)
        : [...prevState.isOpen, index];
      return { isOpen: updatedIsOpen };
    });
  };

  renderAccordion = (title, score, content, scoreColor, index, star) => {
    const isOpen = this.state.isOpen.includes(index);
    const size = 42;
    const radius = (size - 10) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (score / 100) * circumference;
    const strokeWidth = size <= 42 ? 2 : 10;
    let strokeColor = "#4BB543"; // Default color
    if (score <= 33) strokeColor = "#C84A10";
    else if (score <= 66) strokeColor = "#FFC107";

    return content ? (
      <div className="accordion" key={index}>
        <div className="accordionContainer">
          <div className="header" onClick={() => this.toggleAccordion(index)}>
            <span className="title">{title}</span>
            {star ? (
              <span
                className="score d-flex items-center gap-2"
                style={{ color: scoreColor, lineHeight: "35px" }}
              >
                {score}{" "}
                <img
                  src={star}
                  alt="star"
                  style={{ width: "14px", height: "14px", marginTop: "-2px" }}
                />
              </span>
            ) : (
              <svg width={size} height={size} style={{ marginLeft: "auto" }}>
                <circle
                  cx={size / 2}
                  cy={size / 2}
                  r={radius}
                  stroke="#E6EAEF"
                  strokeWidth={strokeWidth}
                  fill="transparent"
                />
                <circle
                  cx={size / 2}
                  cy={size / 2}
                  r={radius}
                  stroke={strokeColor}
                  strokeWidth={strokeWidth}
                  fill="transparent"
                  strokeDasharray={circumference}
                  strokeDashoffset={offset}
                  style={{ transition: "stroke-dashoffset 0.5s ease-in-out" }}
                />
                <text
                  x="50%"
                  y="50%"
                  textAnchor="middle"
                  dy=".3em"
                  fontSize={size <= 42 ? "10" : "20"}
                  fill="#1C1B1F"
                  fontWeight={700}
                >
                  {score}%
                </text>
              </svg>
            )}
            <span className="material-symbols-outlined arrow">
              {isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}
            </span>
          </div>
        </div>
        {isOpen && (
          <div className="content">
            <p>{content}</p>
          </div>
        )}
      </div>
    ) : (
      ""
    );
  };

  render() {
    const { summary, userDetails, longValueDetails } = this.props;

    const formattedInfo = formatInfo(summary.entities) || [];

    return (
      <div>
        {summary &&
          summary.language &&
          summary.is_escalation_necessary &&
          summary.is_conversation_complete && (
            <FuctionSection>
              <div className="details-row">
                <div className="detail-item">
                  <span className="detail-key">Toxic Language</span>
                  <span className="detail-value">
                    {summary && summary.tl_nsfw}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-key">Language</span>
                  <span className="detail-value">
                    {summary && summary.language}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-key">Escalation Necessary</span>
                  <span className="detail-value">
                    {summary && summary.is_escalation_necessary}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-key">Conversation Complete</span>
                  <span className="detail-value">
                    {summary && summary.is_conversation_complete}
                  </span>
                </div>
              </div>
            </FuctionSection>
          )}

        {/* Rendering summary section */}
        {summary && summary.topic && summary.summary ? (
          <SummarySection>
            <div className="header">
              <img src="/images/summary.png" alt="Summary" />
              <h5 className="text">Summary</h5>
              <div className="sentiment">
                {getSentimentIcon(
                  summary && summary.sentiment ? summary.sentiment : ""
                )}
              </div>
            </div>
            <div className="topic">
              <span className="topic-text">Topic:</span>
              <span className="topic-content">
                {summary && summary.topic ? summary.topic : ""}
              </span>
            </div>
            <div className="summary-content">
              <p>{summary && summary.summary ? summary.summary : ""}</p>
            </div>
          </SummarySection>
        ) : (
          ""
        )}

        {/* Rendering tags */}
        {summary && summary.tags ? (
          <TagsSection>
            <HeadingStyle>Auto-applied Tags</HeadingStyle>

            <div className="tag-list">
              {(typeof summary.tags === "string"
                ? summary.tags.match(/[^,\s][^,]*/g) || []
                : summary.tags
              ).map((tag, index) => (
                <div className="tag" key={index}>
                  <span>{tag}</span>
                </div>
              ))}
            </div>
          </TagsSection>
        ) : (
          ""
        )}

        {summary && (summary.entities || summary.entitiesObject) ? (
          <DetailSection>
            <HeadingStyle>Details</HeadingStyle>
            <table className="details-table" style={{ width: "auto" }}>
              <tbody>
                {/* Check if 'entities' is available and render it */}
                {Array.isArray(formattedInfo)
                  ? formattedInfo.map(({ key, values }) => (
                    <tr key={key}>
                      <td className="long-value-row detail-key">{key}:</td>
                      <td className="detail-value">{values.join(", ")}</td>
                    </tr>
                  ))
                  : null}

                {/* Check if 'entitiesObject' is available and render it */}
                {summary.entitiesObject && typeof summary.entitiesObject === "object"
                  ? Object.entries(summary.entitiesObject).map(([key, value]) => (
                    <tr key={key}>
                      <td className="long-value-row detail-key">{key}:</td>
                      <td className="detail-value">{value}</td>
                    </tr>
                  ))
                  : null}
              </tbody>
            </table>
          </DetailSection>
        ) : (
          ""
        )}


        {/* {summary && summary.entities ? (
          <DetailSection>
            <HeadingStyle>Details</HeadingStyle>
            <table className="details-table" style={{ width: "auto" }}>
              <tbody>

                {summary && summary.entities
                  ? Array.isArray(formattedInfo) &&
                  formattedInfo.map(({ key, values }) => (
                    <tr key={key}>
                      <td className="long-value-row detail-key">{key}:</td>
                      <td className="detail-value">{values.join(", ")}</td>
                    </tr>
                  ))
                  : ""}
              </tbody>
            </table>
          </DetailSection>
        ) : (
          ""
        )} */}

        {/* Rendering static details */}
        {summary &&
          Object.keys(summary).some((key) => key.startsWith("static__"))
          ? Object.keys(summary).some((key) => key.startsWith("static__")) && (
            <DetailSection>
              <HeadingStyle>Call details</HeadingStyle>
              <table className="details-table">
                <tbody>
                  {createRows(userDetails)}
                  {Object.keys(longValueDetails).map((key, index) => (
                    <tr key={index}>
                      <td className="long-value-row detail-key">{key}:</td>
                      <td className="detail-value" colSpan={3}>
                        {longValueDetails[key]}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </DetailSection>
          )
          : ""}

        {summary && summary.pii && summary.pci ? (
          <ChecklistSection>
            <div className="checklist">
              <div className="checklist-label">
                <img
                  src={
                    summary && summary.pii && summary.pii.includes("Yes")
                      ? "/images/pii.png"
                      : "/images/pci.png"
                  }
                />
                <span>PII</span>
              </div>
              <div className="checklist-label tooltip">
                <img
                  src={
                    summary && summary.pci && summary.pci.includes("Yes")
                      ? "/images/pii.png"
                      : "/images/pci.png"
                  }
                />
                <span>PCI</span>
              </div>
            </div>
          </ChecklistSection>
        ) : (
          ""
        )}

        {/* {summary && summary.pii && summary.pci ? (
          <ChecklistSection>
            <div className="checklist">
              <div
                className="checklist-label tooltip"
                style={{ cursor: "pointer" }}
              >
                <img
                  src={
                    summary && summary.pii && summary.pii.includes("Yes")
                      ? "/images/pii.png"
                      : "/images/pci.png"
                  }
                />
                <span>PII</span>
                {summary && summary.pii && summary.pii.includes("Yes") && (
                  <div
                    className="tooltip-text"
                    dangerouslySetInnerHTML={{
                      __html: formatInfo(summary.pii_info),
                    }}
                  ></div>
                )}
              </div>

              <div className="checklist-label tooltip">
                <img
                  src={
                    summary && summary.pci && summary.pci.includes("Yes")
                      ? "/images/pii.png"
                      : "/images/pci.png"
                  }
                />
                <span>PCI</span>
                {summary && summary.pci && summary.pci.includes("Yes") && (
                  <div
                    className="tooltip-text"
                    dangerouslySetInnerHTML={{
                      __html: formatInfo(summary.pii_info),
                    }}
                  ></div>
                )}
              </div>
            </div>
          </ChecklistSection>
        ) : (
          ""
        )} */}

        {/* Rendering accordions */}
        <AccordionSection>
          {this.renderAccordion(
            "Confidence Score",
            summary.confidence_score,
            summary.confidence_score_exp,
            "#4BB543",
            0,
            ""
          )}
          {this.renderAccordion(
            "AI Rating for User Questions",
            summary.ai_rating_for_user_question,
            summary.ai_rating_exp_for_user_question,
            "#000000",
            1,
            "/images/starImg.png"
          )}
          {this.renderAccordion(
            "AI Rating for AI Response",
            summary.ai_rating_for_ai_response,
            summary.ai_rating_exp_for_ai_response,
            "#000000",
            2,
            "/images/starImg.png"
          )}
        </AccordionSection>
      </div>
    );
  }
}

export default SummarySectionComponent;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/SummarySectionComponent.js